import media from 'src/style-utils/media-queries';
import styled from 'styled-components';

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  ${media.tablet`
    gap: 3.2rem;
  `}
`;
